import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import { auth } from '../firebase';

const api: AxiosInstance = axios.create({
  // Empty string = relative URLs; Firebase Hosting rewrites /api/** → Cloud Run.
  // For local dev, set REACT_APP_API_URL=http://localhost:8080 in .env.local.
  baseURL: process.env.REACT_APP_API_URL || '',
  // No default Content-Type — Axios auto-sets 'application/json' for plain objects
  // and lets the browser set 'multipart/form-data; boundary=...' for FormData.
  // Hardcoding 'application/json' here causes boundary mismatches on file uploads.
  timeout: 30_000,
});

// Attach fresh Firebase ID token to every request
api.interceptors.request.use(async (config: InternalAxiosRequestConfig) => {
  const user = auth.currentUser;
  if (user) {
    const token = await user.getIdToken();
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// On 401: force-refresh token and retry once
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retried) {
      originalRequest._retried = true;
      const user = auth.currentUser;
      if (user) {
        const freshToken = await user.getIdToken(true);
        originalRequest.headers.Authorization = `Bearer ${freshToken}`;
        return api.request(originalRequest);
      }
    }
    return Promise.reject(error);
  },
);

export default api;
